import { faqItems } from '@/mocks/categories';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://vigorbuy.beer';
const logoUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'VigorBuy Spreadsheet',
  url: siteUrl,
  description: 'Trusted VigorBuy Spreadsheet resources, buying guides, QC tutorials, and expert tips.',
  logo: {
    '@type': 'ImageObject',
    url: logoUrl,
  },
};

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'VigorBuy Spreadsheet',
  url: siteUrl,
  description: 'Trusted VigorBuy Spreadsheet resources, buying guides, QC tutorials, and expert tips.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const faqPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export default function HomeSchema() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPageSchema) }} />
    </>
  );
}